import React from 'react'

import PropTypes from 'prop-types'

const ScrollableTable = ({headers, data, withIndex = false}) => {
  if (withIndex) {
    headers = [ '#', ...headers ]
    data = data.map((rowData, rowIndex) => {
      return [ `${rowIndex + 1}.`, ...rowData ]
    })
  }

  return (
  <div className={'cls-st-table-container'}>
    <div className={'cls-st-table-wrapper'}>
      <table className={'cls-st-table'}>
        {/* Headers */}
        <thead className={'cls-st-thead'}>
        <tr className={'cls-st-thead-row'}>
          {headers.map(header => (
            <th key={`header-${header}`} className={'cls-st-thead-cell'}>{header}</th>
          ))}
        </tr>
        </thead>
        <tbody>
        {/* Rows */}
        {data.map((rowData, rowIndex) => (
          <tr
            className={'cls-st-regular-row'}
            key={rowIndex}
          >
            {rowData.map((cellData, index) => (
              <td key={index} className={'cls-st-tdata'}>{cellData}</td>
            ))}
          </tr>
        ))}
        </tbody>
      </table>
    </div>
  </div>)
}

ScrollableTable.propTypes = {
  headers: PropTypes.array.isRequired,
  data: PropTypes.array.isRequired,
  withIndex: PropTypes.bool,
}

export default ScrollableTable
